import { createContext, useReducer } from "react";
import { reducer } from "./reducer";
import { initialState } from "./state";

export const OrganisasiCtx = createContext();

function OrganisasiContext({ children }) {
	const [state, dispatch] = useReducer(reducer, initialState);

	return (
		<OrganisasiCtx.Provider value={{ state, dispatch }}>
			{children}
		</OrganisasiCtx.Provider>
	);
}

export default OrganisasiContext;
